import {
  NotificationsAllProps,
  NotificationsDeviceRegisterProps,
  NotificationsMarkReadProps,
} from "_interfaces/http-requests/notifications";
import {
  NOTIFICATIONS_ALL,
  NOTIFICATIONS_DEVICE_REGISTER,
  NOTIFICATIONS_DEVICE_UNREGISTER,
  NOTIFICATIONS_MARK_ALL_READ,
  NOTIFICATIONS_MARK_READ,
} from "config/endpoint";
import { HTTP } from "functions/http";

export const NotificationsAll = ({ DATA }: NotificationsAllProps) => {
  return HTTP({
    Method: "POST",
    Url: NOTIFICATIONS_ALL,
    Data: DATA,
  });
};

export const NotificationsMarkAllRead = () => {
  return HTTP({
    Method: "POST",
    Url: NOTIFICATIONS_MARK_ALL_READ,
  });
};

export const NotificationsMarkRead = ({ ID }: NotificationsMarkReadProps) => {
  return HTTP({
    Method: "POST",
    Url: NOTIFICATIONS_MARK_READ(ID),
  });
};

export const NotificationsDeviceRegister = async ({
  DATA,
}: NotificationsDeviceRegisterProps) => {
  return await HTTP({
    Method: "POST",
    Url: NOTIFICATIONS_DEVICE_REGISTER,
    Data: DATA,
  });
};

export const NotificationsDeviceUnregister = () => {
  return HTTP({
    Method: "POST",
    Url: NOTIFICATIONS_DEVICE_UNREGISTER,
  });
};
